export default __webpack_public_path__ + "static/media/link-share.83d8ed08.svg";